import React from "react"

import { blokType } from "../../types"
import { StyledList, StyledListTitle, StyledListGroup } from "./partials"
import Item from "./Item"

export interface ListProps {
  title: string
  items: blokType[]
  list_color: string
  remove_bullets: boolean
  remove_border: boolean
}

export const ListCmp: React.FC<ListProps> = ({
  title,
  items,
  list_color,
  remove_bullets,
  remove_border,
}) => (
  <StyledList>
    {title && (
      <StyledListTitle list_color={list_color} remove_border={remove_border}>
        {title}
      </StyledListTitle>
    )}
    {items && (
      <StyledListGroup
        title_exists={title ? true : false}
        remove_bullets={remove_bullets}
        list_color={list_color}
        remove_border={remove_border}
      >
        {items.map((content: blokType) => (
          <Item title={content.title} key={content._uid} />
        ))}
      </StyledListGroup>
    )}
  </StyledList>
)
